import React, { useEffect, useState } from "react";
import { ValidationMessage, hasRole } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  STATE_EDIT,
  STATE_UPDATE,
  COUNTRY_LIST_DROPDOWN
} from "../../routes/routes";
import { toast } from "react-toastify";
import { FullPageLoader } from '../../components/common/Loader'; // Import the loader component
import { STATE_UPDATED } from "../../constant/constant";
import Select from "react-select";
import { memberFormSelectStyles } from "../../constant/selectStyles";

const StateEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState();
  const [errors, setErrors] = useState({});
  const [countryOptions, setCountryOptions] = useState({});

  const auth_user = JSON.parse(localStorage.getItem("user"));

  /**   *
   * @param {*} input
   * @param {*} callback
   */


  const submit = () => {
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .put(STATE_UPDATE + id, requestBody)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(STATE_UPDATED);
          navigate("/states");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      }).finally(() => {
        setBtnDisabled(false);
      });
  };
  useEffect(() => {
    axios.get(STATE_EDIT + id).then((res) => {
      if (res.status === 200 && res.data.success) {
        let responseData = res.data.data;
        setForm({
          id: responseData?.id,
          name: responseData?.name,
          country_id: responseData?.country_id,
          country_id_selected: {
            value: Number(responseData?.country_id),
            label: responseData?.country_name,
          },
          status: responseData?.status
        });
      }
    }).finally(() => {
      setLoading(false);
    });

    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();

  }, [id]);
  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">States</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li>
                  <Link to={"/states"}>
                    <span>States List</span>
                  </Link>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Edit State</span></li>
              </ol>

            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/states"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        {/* <div className="demo-inline-spacing d-flex justify-content-end mb-3">
          <Link to={"/states"}>
            <button type="button" className="btn btn-dark rounded-pill">
              <i className="bx bx-exit"></i> back
            </button>
          </Link>
        </div> */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Edit State</h5> */}
              </div>
              <div className="card-body app-form-fields">
                <form>
                  <div className="row">

                    {hasRole([1]) &&
                      <div className="col-6 mb-3">
                        <label htmlFor="country_id" className="form-label">
                          Country<span className="text-danger">*</span>
                        </label>
                        <Select styles={memberFormSelectStyles}
                          options={countryOptions}
                          value={form?.country_id_selected}
                          isDisabled={true}
                          onChange={(selected) => {
                            setForm({ ...form, country_id: Number(selected.value), country_id_selected: selected });
                          }}
                        />
                        <ValidationMessage error={errors} name="country_id" />
                      </div>
                    }


                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="name"
                        >
                          State Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Name"
                          onChange={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                          defaultValue={form?.name}
                        />
                        <ValidationMessage error={errors} name="name" />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/states"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StateEdit;
